import type { Zone } from '@seek/audience-zones';
import type { Brand, Country, Language } from '@seek/melways-sites';
import { middleware as metricsMiddleware } from '@seek/metrics-js';

import analytics from 'src/modules/analytics/accountMiddlewareAnalytics';
import type { ApiInterface } from 'src/modules/api';

import createAnalyticsMiddleware from './createAnalyticsMiddleware';
import dependencyInjector from './dependencyInjector';

declare global {
  interface Window {
    CONFIG: any;
    __REDUX_DEVTOOLS_EXTENSION__: any;
  }
}

export default (
  siteCountry: Country,
  brand: Brand,
  siteLanguage: Language,
  zone: Zone,
  api: ApiInterface,
) => [
  dependencyInjector({ api }),
  metricsMiddleware.reduxActionMetrics({}),
  createAnalyticsMiddleware(
    analytics({
      pageAnalytics: {
        siteCountry,
        brand,
        siteLanguage,
        zone,
      },
    }),
  ),
];
